/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { rgb } from '../../UNSAFE_Theme';
import { colorSchemeVars } from '@oracle/oraclejet-internal-theme-contract/themeContract.css';

/**
 * Returns the dvt categorical colors.
 */
export function getColorRamp() {
  return Array.from({ length: 12 }, (_, index: number) => {
    return rgb(
      colorSchemeVars.dvt.paletteQualitative[
        (index + 1) as 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
      ]
    );
  });
}
